import { Delta } from "quill/core";

export type QuillClipboardMatcher = [
  string,
  (node: Node, delta: Delta) => Delta,
];

export const quillClipboardMatchers = {
  img: [
    "img",
    (node, delta) => {
      if (!(node instanceof HTMLImageElement)) return delta;
      if (node.style.width) {
        delta.ops[0].attributes = delta.ops[0].attributes || {};
        delta.ops[0].attributes.width = node.style.width;
      }
      if (node.style.height) {
        delta.ops[0].attributes = delta.ops[0].attributes || {};
        delta.ops[0].attributes.height = node.style.height;
      }
      return delta;
    },
  ],
  disallowBackground: [
    "*",
    (_, delta) => {
      for (let i = 0; i < delta.ops.length; i++) {
        // Disallow background color. That's handled at the email block level.
        delete delta.ops[i].attributes?.background;
      }
      return delta;
    },
  ],
} as const satisfies Record<string, QuillClipboardMatcher>;
